/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Dispatch, SetStateAction, useState } from 'react';
import { Modal } from '@app/components/common/Modal/Modal';
import { ReportAlertsDataModel } from '@app/domain/interfaces/report/reportAlertsModel';
import moment from 'moment';
import Dashboard from '@app/components/dashboard/Dashboard';
import { Table } from '@app/components/common/Table/Table';
import { genericExportToExcel } from '@app/utils/exportToExcel';
import alertNameMapping from '@app/constants/AlertsNameMapping';

interface IModalTripGraphicProps {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  mapData: any[];
}

const ModalTripAlerts: React.FC<IModalTripGraphicProps> = ({ visible, setVisible, mapData }) => {
  const [tableData, setTableData] = useState<ReportAlertsDataModel[]>([]);

  const mapAlertsToDataModel = (mapData: any[]): ReportAlertsDataModel[] => {
    return mapData.flatMap((alert, index) =>
      alert.alertas.map((alertaNumber: string) => {
        return {
          id: `${index}-${alertaNumber}-${alert.dataHora}`,
          number: parseInt(alertaNumber),
          name: alertNameMapping[alertaNumber] || 'Unknown',
          dataHora: new Date(alert.dataHora),
          state: alert.estadoViagemAtual.toString(),
        };
      }),
    );
  };

  useState(() => {
    setTableData(mapAlertsToDataModel(mapData));
  });

  const handleExportToExcel = () => {
    const columns = [
      { title: 'Número', dataIndex: 'number' },
      { title: 'Nome', dataIndex: 'name' },
      { title: 'Data e Hora', dataIndex: 'dataHora' },
      { title: 'Estado', dataIndex: 'state' },
    ];

    genericExportToExcel('Alertas da Viagem', columns, tableData);
  };

  const handleSearchOnChange = (event: React.FormEvent<HTMLInputElement>) => {
    const inputValue = event.currentTarget.value.trim().toLowerCase();

    if (inputValue.length > 0) {
      const isNumeric = /^\d+$/.test(inputValue);

      const filteredAlerts = mapAlertsToDataModel(mapData).filter((alert) =>
        isNumeric ? alert.number.toString().includes(inputValue) : alert.name.toLowerCase().includes(inputValue),
      );

      setTableData(filteredAlerts);
    } else {
      setTableData(mapAlertsToDataModel(mapData));
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={() => setVisible(!visible)}
      size="medium"
      footer={null}
      title="Alertas da Viagem"
      width="90vw"
    >
      <Dashboard
        buttonText={''}
        handleButtonClick={() => {}}
        table={
          <Table
            bordered
            columns={[
              { title: 'Número', dataIndex: 'number' },
              { title: 'Nome', dataIndex: 'name' },
              {
                title: 'Data e Hora',
                dataIndex: 'dataHora',
                render: (data: string) => moment(data).format('DD/MM/YYYY HH:mm'),
              },
              { title: 'Estado', dataIndex: 'state' },
            ]}
            dataSource={tableData}
            loading={false}
            rowKey="id"
          />
        }
        placeholderTextSearch="Pesquisar por nº ou nome"
        handleSearchOnChange={handleSearchOnChange}
        exportToExcel={handleExportToExcel}
      />
    </Modal>
  );
};

export default ModalTripAlerts;
